import axios from 'axios';
import { backendserverurl } from '../views/serverconn';

const API_BASE_URL = backendserverurl;

// Create axios instance with default config
const limsAPI = axios.create({
  baseURL: `${API_BASE_URL}/api/lims`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
limsAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

// API Tokens
export const getAPITokens = async () => {
  const response = await limsAPI.get('/tokens/');
  return response.data;
};

export const createAPIToken = async (tokenData) => {
  const response = await limsAPI.post('/tokens/', tokenData);
  return response.data;
};

export const updateAPIToken = async (id, tokenData) => {
  const response = await limsAPI.put(`/tokens/${id}/`, tokenData);
  return response.data;
};

export const deleteAPIToken = async (id) => {
  const response = await limsAPI.delete(`/tokens/${id}/`);
  return response.data;
};

export const activateToken = async (id) => {
  const response = await limsAPI.post(`/tokens/${id}/activate/`);
  return response.data;
};

export const deactivateToken = async (id) => {
  const response = await limsAPI.post(`/tokens/${id}/deactivate/`);
  return response.data;
};

export const regenerateToken = async (id) => {
  const response = await limsAPI.post(`/tokens/${id}/regenerate/`);
  return response.data.new_token;
};

// Sample Confirmations
export const getSampleConfirmations = async () => {
  const response = await limsAPI.get('/confirmations/');
  return response.data;
};

export const confirmSample = async (id, data = {}) => {
  const response = await limsAPI.post(`/confirmations/${id}/confirm/`, data);
  return response.data;
};

export const rejectSample = async (id, data = {}) => {
  const response = await limsAPI.post(`/confirmations/${id}/reject/`, data);
  return response.data;
};

// Integration Logs
export const getIntegrationLogs = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.integration_type) {
    params.append('integration_type', filters.integration_type);
  }
  if (filters.status) {
    params.append('status', filters.status);
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.user) {
    params.append('user', filters.user);
  }
  if (filters.dateRange && filters.dateRange.length === 2) {
    params.append('timestamp_after', filters.dateRange[0].toISOString());
    params.append('timestamp_before', filters.dateRange[1].toISOString());
  }

  const response = await limsAPI.get(`/logs/?${params.toString()}`);
  return response.data;
};

export const getLIMSStatistics = async () => {
  const response = await limsAPI.get('/logs/statistics/');
  return response.data;
};

export const exportLogs = async () => {
  const response = await limsAPI.get('/logs/export/', {
    responseType: 'blob',
  });
  
  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'lims_integration_logs.csv');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Error handling
limsAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Unauthorized: Please log in again');
    } else if (error.response?.status === 403) {
      console.error('Access denied: You may not have permission to access this resource');
    } else {
      console.error('API Error:', error.response?.data || error.message);
    }
    return Promise.reject(error);
  }
);

export default limsAPI;
